var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .IconDevices_a {\n        fill: #085170;\n        opacity: 0.5;\n      }\n\n      .IconDevices_b {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "IconDevices_a",
    width: 42,
    height: 42,
    rx: 21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.671 11.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IconDevices_b",
    d: "M16.98,18.244H2.684A2.687,2.687,0,0,1,0,15.563V2.682A2.687,2.687,0,0,1,2.684,0h14.3a2.683,2.683,0,0,1,2.678,2.682V15.563A2.683,2.683,0,0,1,16.98,18.244ZM7.152,12.063a.893.893,0,0,0,0,1.785h5.361a.893.893,0,0,0,0-1.785Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevices);
export default __webpack_public_path__ + "static/media/IconDevices.21a050fe19c1ef67057ac038784444f6.svg";
export { ForwardRef as ReactComponent };